export function initGroupReadMore() {
    document.querySelectorAll('.is-style-read-more').forEach((group) => {
        const originalHTML = group.innerHTML;
        setupTruncated(group, originalHTML);
    });
}

function setupTruncated(group, originalHTML) {
    group.innerHTML = originalHTML;

    const wordLimit = 130;
    let currentWordCount = 0;
    let splitOccurred = false;

    const hiddenWrapper = document.createElement('div');
    hiddenWrapper.className = 'js-hidden-content hidden';

    const readMoreBtn = document.createElement('strong');
    readMoreBtn.className = 'js-read-more cursor-pointer';
    readMoreBtn.innerText = ' Read more +';

    const children = Array.from(group.children);

    children.forEach((child) => {
        if (splitOccurred) {
            hiddenWrapper.appendChild(child);

            return;
        }

        const totalWordsInBlock = child.innerText.trim().split(/\s+/).length;

        if (currentWordCount + totalWordsInBlock > wordLimit) {
            const remainingAllowed = wordLimit - currentWordCount;

            if (child.tagName === 'P') {
                const hiddenPara = child.cloneNode(true);
                hiddenPara.innerHTML = '';

                const dotsHidden = document.createElement('span');
                dotsHidden.innerText = '... ';
                hiddenPara.appendChild(dotsHidden);

                splitNodeAtWord(child, hiddenPara, remainingAllowed);

                const dotsVisible = document.createElement('span');
                dotsVisible.innerText = '... ';
                child.appendChild(dotsVisible);
                child.appendChild(readMoreBtn);

                hiddenWrapper.appendChild(hiddenPara);
            } else {
                const dotsVisible = document.createElement('span');
                dotsVisible.innerText = '... ';
                const target = child.previousElementSibling || group;
                target.appendChild(dotsVisible);
                target.appendChild(readMoreBtn);
                hiddenWrapper.appendChild(child);
            }
            splitOccurred = true;
        } else {
            currentWordCount += totalWordsInBlock;
        }
    });

    if (splitOccurred) {
        group.appendChild(hiddenWrapper);

        readMoreBtn.addEventListener('click', () => {
            setupExpanded(group, originalHTML);
        });
    }
}

function setupExpanded(group, originalHTML) {
    group.innerHTML = originalHTML;

    const showLessBtn = document.createElement('strong');
    showLessBtn.className = 'js-read-less cursor-pointer block mt-block';
    showLessBtn.innerText = ' Show less -';

    const lastChild = group.lastElementChild;

    if (lastChild) {
        lastChild.appendChild(showLessBtn);
    } else {
        group.appendChild(showLessBtn);
    }

    showLessBtn.addEventListener('click', () => {
        setupTruncated(group, originalHTML);
        group.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
}

function splitNodeAtWord(sourceNode, destNode, limit) {
    let count = 0;
    const childNodes = Array.from(sourceNode.childNodes);

    childNodes.forEach((node) => {
        if (count >= limit) {
            destNode.appendChild(node);

            return;
        }

        const nodeText = node.textContent || '';
        const words = nodeText
            .trim()
            .split(/\s+/)
            .filter((w) => w.length > 0);
        const nodeWordCount = words.length;

        if (count + nodeWordCount > limit) {
            const wordsNeeded = limit - count;
            const textArray = nodeText
                .trim()
                .split(/\s+/)
                .filter((w) => w.length > 0);
            const stayText = textArray.slice(0, wordsNeeded).join(' ');
            const moveText = textArray.slice(wordsNeeded).join(' ');

            if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = stayText;
                destNode.appendChild(document.createTextNode(moveText));
            } else {
                const cloneForDest = node.cloneNode(true);
                node.innerText = stayText;
                cloneForDest.innerText = moveText;
                destNode.appendChild(cloneForDest);
            }
            count = limit;
        } else {
            count += nodeWordCount;
        }
    });
}
